/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Button,
  Dimmer,
  Grid,
  Header,
  Form,
  Loader,
  Segment,
  Divider,
  Icon,
} from 'semantic-ui-react';
import { required, numericRange } from '@mhub/web-validations';
import AppForm from './AppForm';
import CurrencySymbol from './CurrencySymbol';
import LoanAmount from './LoanAmount';
import { fetchM } from '../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../actions/flash';
import { shareUnitMorCalcCopyFormat } from '../utils/sharing';

export default class MortgageCalculator extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    packagePricings: PropTypes.oneOfType([PropTypes.array]).isRequired,
    projectCurrencies: PropTypes.oneOfType([PropTypes.array]),
    projectID: PropTypes.string,
    unitID: PropTypes.string,
    spaValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    token: PropTypes.string,
    isMobile: PropTypes.bool,
    unitData: PropTypes.shape({
      project: PropTypes.shape({
        maOwnerCompanyBranchID: PropTypes.number,
      }),
    }),
    userAuth: PropTypes.shape({
      isDeveloper: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isExternalAgencyAdmin: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
    }),
  }
  static getPropsToState = (props) => {
    const packagePricings = props.packagePricings || [];
    const token = props.token || '';
    const data = Object.assign({}, MortgageCalculator.defaultValues);
    const result = Object.assign({}, MortgageCalculator.defaultResult);
    const loanMargin = 90;
    data.spaPrice = parseFloat(props.spaValue);
    data.loanAmount = Math.floor((loanMargin / 100) * data.spaPrice);
    return {
      data,
      loanMargin,
      packagePricings,
      result,
      token,
    };
  }
  static defaultValues = {
    loanAmount: 0,
    tenureYear: 35,
    interestRate: 0,
    freeSPALegalFee: false,
    freeSPALegalFeeDisbursements: false,
    freeSPAMOTStampDuty: false,
    freeLALegalFee: false,
    freeLALegalFeeDisbursements: false,
    freeLAStampDuty: false,
    freeValuationFee: false,
    firstTimeBuyer: false,
  }
  static defaultResult = {
    monthlyLoanPayment: 0,
    spaLegalFee: 0,
    spaLegalFeeSST: 0,
    spaLegalFeeDisbursements: 0,
    laLegalFee: 0,
    laLegalFeeSST: 0,
    laLegalFeeDisbursements: 0,
    laStampDuty: 0,
    valuationFee: 0,
    valuationFeeSST: 0,
    valuationFeeDisbursements: 0,
    totalSPAFees: 0,
    totalLAFees: 0,
    totalValuationFees: 0,
    motStampDuty: 0,
    totalAdditionalFees: 0,
  }
  constructor(props) {
    super(props);
    const state = MortgageCalculator.getPropsToState(props);
    this.state = {
      ...state,
      selectedPricingPackage: 'spa_value',
      loading: false,
    };
    this.validation = {
      spaPrice: createRef(),
      loanAmount: createRef(),
      tenureYear: createRef(),
      interestRate: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = MortgageCalculator.getPropsToState(nextProps);
    if (JSON.stringify(this.state.data.spaPrice) !== JSON.stringify(state.data.spaPrice) ||
        JSON.stringify(this.state.packagePricings) !== JSON.stringify(state.packagePricings)) {
      this.setState({
        ...state,
      });
    }
  }
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      res(loading);
    });
  })
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  getPricingPackages = () => {
    const { spaValue } = this.props;
    const packagePricings = this.state.packagePricings.sort((a, b) => a.orderPriority - b.orderPriority);
    const options = [
      {
        text: spaValue,
        amount: spaValue,
        value: 'spa_value',
        content: (
          <Header className="ppItem">
            <div className="name">Unit base selling price</div>
            <div className="value">
              <LoanAmount
                precise={false}
                format="0,000,000.00"
                amount={spaValue}
                prefix={<CurrencySymbol />}
              />
            </div>
          </Header>
        ),
      },
    ];
    packagePricings.forEach((p) => {
      const name = p.isCustomPrice ? p.customName : p.projectPackagePricing.name;
      const newItem = {
        text: p.spaPrice,
        amount: p.spaPrice,
        value: p.id,
        content: (
          <Header className="ppItem">
            <div className="name">{name}</div>
            <div className="value">
              <LoanAmount
                precise={false}
                format="0,000,000.00"
                amount={p.spaPrice}
                prefix={<CurrencySymbol />}
              />
            </div>
          </Header>
        ),
      };
      options.push(newItem);
    });
    return options;
  }
  getLoanMarginOptions = () => {
    let options = [];
    for (let i = 0; i <= 100; i += 1) {
      options = [...options, {
        key: i,
        value: i,
        text: `${i}%`,
      }];
    }
    return options.sort((a, b) => b.value - a.value);
  }
  handleCheckboxChange = (e, d) => {
    const { data } = this.state;
    data[d.name] = !data[d.name];
    this.setState({ data });
  }
  handleAmountChange = (e, d) => {
    const { data, loanMargin } = this.state;
    let loanPercent = loanMargin;
    let amount = 0;
    if (d.value !== '') {
      amount = parseFloat(d.value);
    }
    loanPercent = Math.ceil((amount / data.spaPrice) * 100);
    data.loanAmount = amount;
    this.setState({ data, loanMargin: loanPercent });
  }
  handlePricingPackageChange = (e, d) => {
    const { data, loanMargin } = this.state;
    const selectedPP = d.options.find(o => o.value === d.value);
    if (selectedPP) {
      data.spaPrice = selectedPP.amount;
      data.loanAmount = Math.floor((loanMargin / 100) * data.spaPrice);
    }
    this.setState({ data, selectedPricingPackage: d.value });
  }
  handleChange = (e, d) => {
    const { data } = this.state;
    let { loanMargin } = this.state;
    if (d.name === 'loanMargin') {
      loanMargin = _.toNumber(d.value);
      data.loanAmount = Math.floor((loanMargin / 100) * data.spaPrice);
    }
    data[d.name] = d.value;
    this.setState({ data, loanMargin });
  }
  handleCalculateLoan = () => {
    this.calculateLoan();
  }
  async calculateLoan() {
    await this.setLoading(true);
    const { store } = this.context;
    const { data } = this.state;
    const { projectID, unitID } = this.props;
    const validations = await AppForm.validate(this.validation, data);
    const errMessages = validations.filter(v => !v.isValid);
    if (errMessages.length > 0) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errMessages.map(l => l.message) }));
      return;
    }
    const body = Object.assign(data, {
      spaPrice: parseFloat(data.spaPrice),
      loanAmount: parseFloat(data.loanAmount),
      tenureYear: parseFloat(data.tenureYear),
      interestRate: parseFloat(data.interestRate),
    });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/units/${unitID}/calc_mortgage/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(body),
      }));
    } catch (err) {
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    const result = await res.json();
    await this.setLoading(false);
    await this.setComponentState({ result });
    store.dispatch(flashSuccessMessage({
      header: 'Calculate Success',
      message: 'Result has been generated',
    }));
  }
  handleResetChanges = () => {
    const data = Object.assign({}, MortgageCalculator.defaultValues);
    const result = Object.assign({}, MortgageCalculator.defaultResult);
    const loanMargin = 90;
    data.spaPrice = parseFloat(this.props.spaValue);
    data.loanAmount = Math.floor((loanMargin / 100) * data.spaPrice);
    this.setState({
      data,
      loanMargin,
      result,
      selectedPricingPackage: 'spa_value',
    });
  }
  handleCopyShareInfo = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { userAuth } = this.props;
    const { data, loanMargin, result, selectedPricingPackage, packagePricings } = this.state;
    const { unitData } = this.props;
    let selectedPricingPackageName = 'Unit base selling price';
    if (selectedPricingPackage !== 'spa_value') {
      const selectedPP = packagePricings.find(p => p.id === selectedPricingPackage);
      selectedPricingPackageName = selectedPP.isCustomPrice ? selectedPP.customName : selectedPP.projectPackagePricing.name;
    }
    const copyText = shareUnitMorCalcCopyFormat(unitData, data, loanMargin, result, userAuth, selectedPricingPackageName);
    const textArea = document.createElement('textarea');
    textArea.value = copyText;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
    store.dispatch(flashSuccessMessage({
      header: 'Copy Success',
      message: 'Successfully copied cost details to your clipboard',
    }));
  }
  renderResultSegment = () => {
    const { loading, result } = this.state;
    const { projectCurrencies } = this.props;
    const resultData = [
      { name: 'totalSPAFees', title: 'SPA', value: result.totalSPAFees, isTotal: true },
      { name: 'spaLegalFee', title: 'Legal fee (Property value)', value: result.spaLegalFee },
      { name: 'spaLegalFeeSST', title: 'Legal fee SST (8%)', value: result.spaLegalFeeSST },
      { name: 'spaLegalFeeDisbursements', title: 'Legal disbursements*', value: result.spaLegalFeeDisbursements },
      { name: 'totalLAFees', title: 'Loan agreement', value: result.totalLAFees, isTotal: true },
      { name: 'laLegalFee', title: 'Legal fee (Loan amount)', value: result.laLegalFee },
      { name: 'laLegalFeeSST', title: 'Legal fee SST (8%)', value: result.laLegalFeeSST },
      { name: 'laLegalFeeDisbursements', title: 'Legal disbursements*', value: result.laLegalFeeDisbursements },
      { name: 'laStampDuty', title: 'Stamp duty', value: result.laStampDuty },
      { name: 'totalValuationFees', title: 'Valuation fees', value: result.totalValuationFees, isTotal: true },
      { name: 'valuationFee', title: 'Valuation fee (Property value)', value: result.valuationFee },
      { name: 'valuationFeeSST', title: 'Valuation fee SST (8%)', value: result.valuationFeeSST },
      { name: 'valuationFeeDisbursements', title: 'Disbursements*', value: result.valuationFeeDisbursements },
      { name: 'totalMotStampDuty', title: 'Instrument of transfer (MoT / DoA)', value: '', isTotal: true },
      { name: 'motStampDuty', title: 'Stamp duty', value: result.motStampDuty },
    ];
    return (
      <Segment className="resultBreakdown">
        <Grid className="totalGrid" columns={2}>
          <Grid.Column width={13}>
            <Grid.Row style={{ paddingTop: '1rem' }} className="title">
              Estimated monthly payment
            </Grid.Row>
            <Grid.Row className="value">
              <LoanAmount
                projectCurrencies={projectCurrencies}
                format="0,000,000.00"
                amount={result.monthlyLoanPayment}
                prefix={<CurrencySymbol />}
                precise={false}
              />
            </Grid.Row>
          </Grid.Column>
          <Grid.Column verticalAlign="middle" textAlign="right" width={3}>
            <Button
              basic
              icon
              size="small"
              title="Click to copy"
              onClick={this.handleCopyShareInfo}
            >
              <Icon name="copy outline" />
            </Button>
          </Grid.Column>
        </Grid>
        <Divider />
        <Dimmer style={{ zIndex: 20 }} active={loading} inverted>
          {loading && <Loader inline="centered">Loading</Loader>}
        </Dimmer>
        <Grid.Column width={16} style={{ marginBottom: '1rem' }}>
          <p className="title">Additional cost</p>
        </Grid.Column>
        { resultData.map((rd, idx) => (
          <Grid verticalAlign="middle" key={idx}>
            <Grid.Column computer={10} tablet={8} mobile={9} verticalAlign="middle">
              <p className={rd.isTotal ? 'totalFee' : 'fee'}>
                {rd.title}
              </p>
            </Grid.Column>
            <Grid.Column computer={6} tablet={8} mobile={7} verticalAlign="middle" textAlign="right">
              <p
                className={rd.isTotal || rd.name === 'motStampDuty' ? 'totalFee' : 'fee'}
                style={{ paddingTop: rd.name === 'motStampDuty' ? '0' : undefined }}
              >
                { rd.value !== '' ? (
                  <LoanAmount
                    projectCurrencies={projectCurrencies}
                    format="0,000,000.00"
                    amount={rd.value}
                    prefix={<CurrencySymbol />}
                    precise={false}
                  />
                  ) : '' }
              </p>
            </Grid.Column>
          </Grid>
        ))
        }
        <Divider />
        <Grid columns={2} className="totalGrid">
          <Grid.Row>
            <Grid.Column width={10} className="title">
              Estimated total additional cost
            </Grid.Column>
            <Grid.Column width={6} textAlign="right">
              * Actual amount may vary
            </Grid.Column>
          </Grid.Row>
          <Grid.Column className="value">
            <LoanAmount
              projectCurrencies={projectCurrencies}
              format="0,000,000.00"
              amount={result.totalAdditionalFees}
              prefix={<CurrencySymbol />}
              precise={false}
            />
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
  render() {
    const {
      data,
      loanMargin,
      selectedPricingPackage,
      loading,
    } = this.state;
    return (
      <Grid className="MortgageCalculator">
        <Grid.Row>
          <Grid.Column mobile={16} tablet={8} computer={8}>
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={5}>
                <b>SPA price</b>
              </Grid.Column>
              <Grid.Column textAlign="right" width={11}>
                <Form.Select
                  className="ppDropdown"
                  options={this.getPricingPackages()}
                  value={selectedPricingPackage}
                  selection
                  fluid
                  onChange={this.handlePricingPackageChange}
                />
              </Grid.Column>
            </Grid>
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={5}>
                <b>Loan amount</b>
              </Grid.Column>
              <Grid.Column textAlign="right" width={11}>
                <Grid verticalAlign="middle">
                  <Grid.Column textAlign="left" computer={4} tablet={6} mobile={5} style={{ paddingRight: '0' }}>
                    <Form.Select
                      fluid
                      name="loanMargin"
                      options={this.getLoanMarginOptions()}
                      placeholder="0%"
                      selectOnBlur={false}
                      value={loanMargin}
                      onChange={this.handleChange}
                    />
                  </Grid.Column>
                  <Grid.Column textAlign="right" computer={12} tablet={10} mobile={11}>
                    <AppForm.Input
                      hideMessage
                      name="loanAmount"
                      type="number"
                      min="0"
                      value={data.loanAmount}
                      validateLabel="Loan amount"
                      onChange={this.handleAmountChange}
                      step=".01"
                      ref={this.validation.loanAmount}
                      validation={[
                        (v, o) => numericRange(v, {
                          ...o,
                          min: 1,
                          max: data.spaPrice,
                        }),
                      ]}
                    />
                  </Grid.Column>
                </Grid>
              </Grid.Column>
            </Grid>
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={5}>
                <b>Loan tenure (Years)</b>
              </Grid.Column>
              <Grid.Column textAlign="right" width={11}>
                <AppForm.Input
                  hideMessage
                  validateLabel="Loan tenure (Years)"
                  name="tenureYear"
                  value={data.tenureYear}
                  onChange={this.handleChange}
                  ref={this.validation.tenureYear}
                  validation={[required, {
                    validate: numericRange,
                    option: {
                      min: 1,
                      max: 35,
                    },
                  }]}
                  type="number"
                  step=".1"
                />
              </Grid.Column>
            </Grid>
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={5}>
                <b>Interest rate (%)</b>
              </Grid.Column>
              <Grid.Column textAlign="right" width={11}>
                <AppForm.Input
                  hideMessage
                  validateLabel="Interest rate (%)"
                  placeholder="Interest rate (%)"
                  name="interestRate"
                  value={data.interestRate}
                  onChange={this.handleChange}
                  ref={this.validation.interestRate}
                  validation={[required, {
                    validate: numericRange,
                    option: {
                      min: 1,
                      max: 100,
                    },
                  }]}
                  type="number"
                  step=".1"
                />
              </Grid.Column>
            </Grid>
            <Divider style={{ margin: '2rem 0' }} />
            <Grid.Column>
              <p className="title">Additional discount</p>
            </Grid.Column>
            <Grid.Column style={{ marginTop: '1.5em', marginBottom: '4.5rem' }} computer={8} tablet={16} mobile={16}>
              <Form.Group grouped>
                <Form.Group>
                  <Form.Field>
                    <Form.Group className="form-group">
                      <Form.Field className="form-label" label="Free SPA legal fee" />
                      <Form.Field className="form-value">
                        <Form.Checkbox
                          toggle
                          name="freeSPALegalFee"
                          checked={data.freeSPALegalFee}
                          onChange={this.handleCheckboxChange}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Field className="form-label" label="Free SPA legal disbursements" />
                      <Form.Field className="form-value">
                        <Form.Checkbox
                          toggle
                          name="freeSPALegalFeeDisbursements"
                          checked={data.freeSPALegalFeeDisbursements}
                          onChange={this.handleCheckboxChange}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Field className="form-label" label="Free SPA stamp duty / MoT" />
                      <Form.Field className="form-value">
                        <Form.Checkbox
                          toggle
                          name="freeSPAMOTStampDuty"
                          checked={data.freeSPAMOTStampDuty}
                          onChange={this.handleCheckboxChange}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Field className="form-label" label="Free Loan legal fee" />
                      <Form.Field className="form-value">
                        <Form.Checkbox
                          toggle
                          name="freeLALegalFee"
                          checked={data.freeLALegalFee}
                          onChange={this.handleCheckboxChange}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Field className="form-label" label="Free Loan legal disbursements" />
                      <Form.Field className="form-value">
                        <Form.Checkbox
                          toggle
                          name="freeLALegalFeeDisbursements"
                          checked={data.freeLALegalFeeDisbursements}
                          onChange={this.handleCheckboxChange}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Field className="form-label" label="Free Loan stamp duty" />
                      <Form.Field className="form-value">
                        <Form.Checkbox
                          toggle
                          name="freeLAStampDuty"
                          checked={data.freeLAStampDuty}
                          onChange={this.handleCheckboxChange}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Field className="form-label" label="Free Valuation fee" />
                      <Form.Field className="form-value">
                        <Form.Checkbox
                          toggle
                          name="freeValuationFee"
                          checked={data.freeValuationFee}
                          onChange={this.handleCheckboxChange}
                        />
                      </Form.Field>
                    </Form.Group>
                    <Form.Group className="form-group">
                      <Form.Field className="form-label" label="First time home buyer" />
                      <Form.Field className="form-value">
                        <Form.Checkbox
                          toggle
                          name="firstTimeBuyer"
                          checked={data.firstTimeBuyer}
                          onChange={this.handleCheckboxChange}
                        />
                      </Form.Field>
                    </Form.Group>
                  </Form.Field>
                </Form.Group>
              </Form.Group>
            </Grid.Column>
            <Button
              primary
              content="Calculate"
              onClick={this.handleCalculateLoan}
              disabled={loading}
              floated="right"
            />
            <Button
              floated="right"
              onClick={(e) => {
                e.preventDefault();
                this.handleResetChanges();
              }}
              disabled={loading}
              basic
              content="Reset to default"
              style={{ marginRight: '1rem' }}
            />
          </Grid.Column>
          <Grid.Column style={this.props.isMobile ? { marginTop: '2rem' } : null} mobile={16} tablet={8} computer={8}>
            {this.renderResultSegment()}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MortgageCalculator.jsx